export default "<div *ngIf=\"isLoading\" class=\"module-loader\">\n  <div class=\"spinner spinner-bubble spinner-bubble-primary mr-3\"></div>\n</div>\n"